const LAYOUT_TYPE = {
  grid: 'grid',
  masonry: 'masonry',
};

export default LAYOUT_TYPE;
